import { cn } from "@/utils/cn";
import { memo } from "react";

interface DividerProps {
  orientation?: "horizontal" | "vertical";
  className?: string;
}

export const Divider = memo(function Divider({
  orientation = "vertical",
  className,
}: DividerProps) {
  return (
    <div
      className={cn(
        "bg-gray-theme",
        orientation === "vertical" ? "w-px h-full" : "h-px w-full",
        className,
      )}
      role="separator"
      aria-orientation={orientation}
    />
  );
});
